module.exports = __webpack_public_path__ + "../resources/img/@temp_scan.3a3ff063.jpg";